export const decodeBase64ToExcel = (file: string, type?: string) => {
  return fetch(
    `data:${
      type ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };base64,${file}`
  ).then((e) => e.blob());
};
